import { EXPIRATION_LEAD_TIME_SECONDS } from "../auth/userServices";
import { useAppSelector } from "../store/hooks";
import { useIsAdminUser } from "./useIsAdminUser";
import { useIsUserAuthenticated } from "./useIsUserAuthenticated";

export const useIsNnsrPortalUser = () => {
  const pid = useAppSelector((state) => state.auth.pid);
  const isUserAuthenticated = useIsUserAuthenticated();
  const isAdmin = useIsAdminUser();

  return (includeAdmin: boolean = true): boolean => {
    return (
      (isUserAuthenticated() && pid !== null && pid.trim() !== "") ||
      (includeAdmin && isAdmin())
    );
  };
};
